'use client';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { Ctext } from '@/components/ui/Ctext';
import { ColorType, FontWeight, getFontFamily } from '@/theme';
import { getWitnessCardContentInnerStyle, WITNESS_CARD_CONTENT_WRAPPER_STYLE, WITNESS_CARD_GRADIENT_OVERLAY_STYLE, } from './cwitnesscardStyles';
import type { WitnessCardData } from './Cwitnesscard.types';
interface CwitnesscardContentProps {
    data: WitnessCardData;
    isSticky?: boolean;
}
export function CwitnesscardGradientOverlay() {
    return <div style={WITNESS_CARD_GRADIENT_OVERLAY_STYLE} aria-hidden="true"/>
        ;
}
export function CwitnesscardContent({ data, isSticky, }: CwitnesscardContentProps) {
    return <div style={WITNESS_CARD_CONTENT_WRAPPER_STYLE}>
            <Ccontainer display="flex" flexDirection="column" gap={16} style={getWitnessCardContentInnerStyle(isSticky)}>
                <Ctext size={28} weight={FontWeight.Bold} color={ColorType.Accent} style={{ fontFamily: getFontFamily(), letterSpacing: '-0.02em' }}>
                    {data.title}
                </Ctext>
                <Ctext size={18} weight={FontWeight.Regular} color={ColorType.White} opacity={0.9} style={{ lineHeight: 1.6 }}>
                    {data.description}
                </Ctext>
            </Ccontainer>
        </div>
        ;
}
